import { useCallback, useEffect, useState } from "react";
import { useDropdown } from "../../hooks/useDropdown";
import { useSelector } from "react-redux";
import { resetData } from "../../features/login/LoginSlice";
import { useDispatch } from "react-redux";
import { saveCartId } from "../../features/Cart/CartSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { setCompareListId } from "../../features/CompareList/CompareListSlice";
import { resetViewData } from "../../features/recentlyView/RecentlyViewSlice";

export const UseMainHeader = (props) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { ConfigData } = useSelector((state) => state.homePageSlice);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    elementRef: searchRef,
    expanded: isSearchOpen,
    setExpanded: setIsSearchOpen,
    triggerRef: searchTriggerRef,
  } = useDropdown();

  const handleSearchTriggerClick = useCallback(() => {
    setIsSearchOpen((isOpen) => !isOpen);
  }, [setIsSearchOpen]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleCategorySelection = (category) => {
    setSelectedCategory([...selectedCategory, category]);
  };

  const handleBack = () => {
    const categories = [...selectedCategory];
    categories.pop();
    setSelectedCategory(categories);
  };

  const {
    elementRef: navbarMobileRef,
    expanded: isNavbarMobileOpen,
    setExpanded: setIsNavbarMobileOpen,
    triggerRef: navbarMobileTriggerRef,
  } = useDropdown();

  const handleNavbarMobileTriggerClick = useCallback(() => {
    setIsNavbarMobileOpen((isOpen) => !isOpen);
  }, [setIsNavbarMobileOpen]);

  const handleLogout = () => {
    try {
      dispatch(resetData());
      dispatch(saveCartId(""));
      dispatch(setCompareListId(""));
      dispatch(resetViewData());
      navigate("/");
    } catch (error) {
      if (process.env.NODE_ENV !== "production") {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    setIsSearchOpen(false);
  }, [location.search]);

  return {
    handleSearchTriggerClick,
    searchTriggerRef,
    searchRef,
    isSearchOpen,
    isScrolled,
    ConfigData,
    selectedCategory,
    handleCategorySelection,
    handleBack,
    navbarMobileRef,
    isNavbarMobileOpen,
    navbarMobileTriggerRef,
    handleNavbarMobileTriggerClick,
    handleLogout,
  };
};
